<div class="features" *ngIf="features.length" #featuresContainer>
  <div class="d-flex align-items-center" #leftSide>
    <div class="features__title mr-8">{{ "Translation.Spacefeatures" | translate }}:</div>
    <ng-container *ngIf="selectedQuantity">
      <span class="features__selected_count mr-8">{{ selectedQuantity }}</span>
      <span class="clear" *ngIf="selectedQuantity" (click)="clearSelected()">{{ "Translation.Clear" | translate }}</span>
    </ng-container>
  </div>
  <div *ngFor="let feature of features | slice:0:visibleFeatures; let i = index" #featureElement>
    <app-tag [label]="feature.name" [tagIcon]="feature.iconClass" [showTagCount]="true" [count]="feature.amount" [customClass]="feature.selected ? 'selected' : 'unselected'" (click)="toggleSelection(feature, i)">
    </app-tag>
  </div>
  <div #rightSide>
    <span class="show-more" *ngIf="!isExpanded" (click)="expand(true)">{{ "Translation.Showmore" | translate }}</span>
    <span class="show-less" *ngIf="isExpanded" (click)="expand(false)">{{ "Translation.Showless" | translate }}</span>
  </div>
</div>
